import { render } from "./UnitsPage.vue?vue&type=template&id=3f2a92ab&scoped=true&ts=true"
import script from "./UnitsPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./UnitsPage.vue?vue&type=script&lang=ts&setup=true"

import "./UnitsPage.vue?vue&type=style&index=0&id=3f2a92ab&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f2a92ab"],['__file',"src/pages/settings/pages/units/UnitsPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3f2a92ab"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3f2a92ab', __exports__)) {
    api.reload('3f2a92ab', __exports__)
  }
  
  module.hot.accept("./UnitsPage.vue?vue&type=template&id=3f2a92ab&scoped=true&ts=true", () => {
    api.rerender('3f2a92ab', render)
  })

}


export default __exports__